import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Page from '../../components/Page';
import Utils from '../../utils';
import RoutesUtils from '../../utils/routes';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';
import DriveItemUtils from '../../utils/driveItem';
import { DownloadStatus } from '../OfflineManager/reducer';
import UrlUtils from '../../utils/url';
import UserAgentUtils from '../../utils/userAgent';
import { Api } from '../../typings/api';

/**
 * Gets the appropriate bgMedia path based on download status.
 * If downloaded, returns offline path; otherwise returns online URL.
 * This ensures bgMedia renders immediately after download completes.
 */
const getBgMediaPath = (
	driveItemId: number,
	bgMedia: string,
	bgMediaMap: { [k: number]: { status: DownloadStatus; version: number } },
	config: Api.Config
): string => {
	// Check if bgMedia is downloaded for this driveItem
	const bgMediaStatus = bgMediaMap[driveItemId];
	const isDownloaded = bgMediaStatus && bgMediaStatus.status === DownloadStatus.DOWNLOADED;

	// If downloaded and we're on mobile app, use offline path
	if (isDownloaded && UserAgentUtils.isMobileApp) {
		return DriveItemUtils.getFolderBgMediaPath(driveItemId, bgMedia);
	}

	// Otherwise, use online URL
	return UrlUtils.getUrlFromRelUrlWithMediaParam(bgMedia, config);
};

const mapStateToProps = (state: StoreState) => {
	const {
		search,
		routerParamsHistory,
		driveList: { driveItems },
		galleryInfos: {
			config: { applicationGallery },
		},
		offlineManager: { bgMediaMap },
	} = state;

	let prevOriginParam = '';
	const prevRoute = routerParamsHistory[routerParamsHistory.length - 2];

	if (prevRoute && prevRoute.params.origin !== DriveItemListOrigin.Search) {
		prevOriginParam = prevRoute.params.originParam;
	}

	const prevDriveItemId = prevOriginParam ? +prevOriginParam : applicationGallery;
	const isPrevDriveItemFetched = Utils.isDriveItemFetched(prevDriveItemId);

	let backgroundColor = (isPrevDriveItemFetched && driveItems[prevDriveItemId])
		? driveItems[prevDriveItemId].bgColor
		: '';
	let backgroundUrl = (isPrevDriveItemFetched && driveItems[prevDriveItemId])
		? driveItems[prevDriveItemId].bgMedia
		: '';

	if (backgroundUrl) {
		backgroundUrl = getBgMediaPath(prevDriveItemId, backgroundUrl, bgMediaMap, state.galleryInfos.config);
	}

	const origin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const originParam = RoutesUtils.getCurrentOriginParam(routerParamsHistory);

	if (origin) {
		const isFolder = origin === DriveItemListOrigin.Folder;
		const driveItemId = isFolder
			? +originParam || applicationGallery
			: applicationGallery;
		const isDriveItemFetched = Utils.isDriveItemFetched(driveItemId);

		if (isDriveItemFetched && driveItems[driveItemId]) {
			backgroundColor = driveItems[driveItemId].bgColor;
			backgroundUrl = driveItems[driveItemId].bgMedia;

			if (backgroundUrl) {
				backgroundUrl = getBgMediaPath(driveItemId, backgroundUrl, bgMediaMap, state.galleryInfos.config);
			}
		}
	}

	const isDefaultBackground = !backgroundColor && !backgroundUrl;

	if (isDefaultBackground) {
		backgroundUrl = driveItems[applicationGallery] ? driveItems[applicationGallery].bgMedia : '';

		if (backgroundUrl) {
			backgroundUrl = getBgMediaPath(applicationGallery, backgroundUrl, bgMediaMap, state.galleryInfos.config);
		}
	}

	return {
		showSearchField: search.isShown,
		origin,
		originParam,
		backgroundUrl,
		backgroundColor,
		isVideoBackground: backgroundUrl &&
			DriveItemUtils.videoExtensions.includes(`.${Utils.getFileExtension(backgroundUrl)}`),
	};
};

export default connect(mapStateToProps)(Page);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Page/index.tsx